import axios from 'axios';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DateFilterButtonData from '../../common/DateFilterButtonData';
import { ko } from 'date-fns/esm/locale';
import CheckBox from '../../common/CheckBox';
import { changeSaleStatusData, changePeriodData } from '../../common/utils';
import resetIcon from '../../../img/resetIcon.png';

function HubSearch(props) {
	// function HubSearch(props) {
	const qs = require('qs');

	const [CheckedSaleStatus, setCheckedSaleStatus] = useState(['SALE', 'SOLDOUT', 'EXTINCTION', 'EXCEPTION']);
	const [SaleStatusList, setSaleStatusList] = useState(['SALE', 'SOLDOUT', 'EXTINCTION', 'EXCEPTION']); // 초기값 설정
	const [manageCode, setManageCode] = useState('');
	const [GoodsName, setGoodsName] = useState('');
	const [ModelName, setModelName] = useState('');
	const [ManufacturerName, setManufacturerName] = useState('');
	const [BrandName, setBrandName] = useState('');
	const [Category1, setCategory1] = useState('');
	const [Category1List, setCategory1List] = useState(['대분류1', '대분류2', '대분류3']);
	const [IsCategory1Open, setIsCategory1Open] = useState(false);
	const [IsCategory1Disabled, setIsCategory1Disabled] = useState(true);
	const [Category2, setCategory2] = useState('');
	const [Category2List, setCategory2List] = useState(['중분류1', '중분류2', '중분류3']);
	const [IsCategory2Open, setIsCategory2Open] = useState(false);
	const [IsCategory2Disabled, setIsCategory2Disabled] = useState(true);
	const [Category3, setCategory3] = useState('');
	const [Category3List, setCategory3List] = useState(['소분류1', '소분류2', '소분류3']);
	const [IsCategory3Open, setIsCategory3Open] = useState(false);
	const [IsCategory3Disabled, setIsCategory3Disabled] = useState(true);
	const [Category4, setCategory4] = useState('');
	const [Category4List, setCategory4List] = useState(['세분류1', '세분류2', '세분류3']);
	const [IsCategory4Open, setIsCategory4Open] = useState(false);
	const [IsCategory4Disabled, setIsCategory4Disabled] = useState(true);
	const [VendorList, setVendorList] = useState([]);
	const [CheckedVendor, setCheckedVendor] = useState([]);

	const [Period, setPeriod] = useState('등록기간');
	const [IsPeriodOpen, setIsPeriodOpen] = useState(false);
	const [StartDate, setStartDate] = useState('');
	const [EndDate, setEndDate] = useState('');
	const [BtnClicked, setBtnClicked] = useState('');
	const [Month, setMonth] = useState(new Date().getMonth());
	const [IsDisable, setIsDisable] = useState(false);

	const PageLengthList = ['등록기간', '품절기간', '수정기간'];
	// 날짜 버튼 클릭, 기간 변경 기능
	const handleBtnClicked = (e) => {
		const newValue = e.target.value;
		setBtnClicked(newValue);
		// 오늘 날짜
		let today = new Date();
		let newDay = new Date();
		if (newValue === '오늘') {
			setStartDate(today.valueOf());
			setEndDate(today.valueOf());
		}
		// 1주일 전부터 오늘까지의 기간
		if (newValue === '1주일') {
			setStartDate(newDay.setDate(today.getDate() - 7).valueOf());
			setEndDate(today.valueOf());
		}
		// 1개월 전부터 오늘까지의 기간
		if (newValue === '1개월') {
			setStartDate(newDay.setMonth(today.getMonth() - 1).valueOf());
			setEndDate(today.valueOf());
		}
		// 3개월 전부터 오늘까지의 기간
		if (newValue === '3개월') {
			setStartDate(newDay.setMonth(today.getMonth() - 3).valueOf());
			setEndDate(today.valueOf());
		}
		//6개월 전부터 오늘까지의 기간
		if (newValue === '6개월') {
			setStartDate(newDay.setMonth(today.getMonth() - 6).valueOf());
			setEndDate(today.valueOf());
		}
		// 1년 전부터 오늘까지의 기간
		if (newValue === '1년') {
			setStartDate(newDay.setFullYear(today.getFullYear() - 1).valueOf());
			setEndDate(today.valueOf());
		}
		// 전체
		if (newValue === '전체') {
			setStartDate(null);
			setEndDate(null);
		}
		//unix타임을 반환하는 메서트 date.valueOf()
	};

	const handleMonthChange = (date) => {
		setMonth(date.getMonth());
	};
	const changeClassName = (inputId, newClassName) => {
		//주문일자 버튼 활성화 class 제거 로직
		const inputElement = document.getElementById(inputId);
		if (inputElement) {
			inputElement.className = newClassName;
		} else {
			console.log(`Input element with ID '${inputId}' not found.`);
		}
	};

	const handleInputChange = (value, type) => {
		const newValue = value;

		if (type === 'manageCode') {
			return setManageCode(newValue.split(/,|\s+/));
		} else if (type === 'GoodsName') {
			return setGoodsName(newValue);
		} else if (type === 'ModelName') {
			return setModelName(newValue);
		} else if (type === 'ManufacturerName') {
			return setManufacturerName(newValue);
		} else {
			// BrandName
			return setBrandName(newValue);
		}
	};
	const handleBlurCategory = (e) => {
		e.preventDefault();
		setTimeout(() => {
			setIsCategory1Open(false);
			setIsCategory2Open(false);
			setIsCategory3Open(false);
			setIsCategory4Open(false);
		}, 200);
	};
	const handleCategoryOpen = (e, type, value = '') => {
		e.preventDefault();
		if (type === 'category1') {
			setIsCategory1Open(!IsCategory1Open);
			setIsCategory2Open(false);
			setIsCategory3Open(false);
			setIsCategory4Open(false);
		} else if (type === 'category2') {
			setIsCategory2Open(!IsCategory2Open);
			setIsCategory1Open(false);
			setIsCategory3Open(false);
			setIsCategory4Open(false);
		} else if (type === 'category3') {
			setIsCategory3Open(!IsCategory3Open);
			setIsCategory1Open(false);
			setIsCategory2Open(false);
			setIsCategory4Open(false);
		} else {
			//category4
			setIsCategory4Open(!IsCategory4Open);
			setIsCategory1Open(false);
			setIsCategory2Open(false);
			setIsCategory3Open(false);
		}
	};
	const handleCategory = (e, type) => {
		e.preventDefault();
		const newValue = e.target.innerText;
		if (type === 'category1' && newValue && newValue.length > 0) {
			setCategory1(newValue);
			setIsCategory2Disabled(false);
		} else if (type === 'category2' && newValue && newValue.length > 0) {
			setCategory2(newValue);
			setIsCategory3Disabled(false);
		} else if (type === 'category3' && newValue && newValue.length > 0) {
			setCategory3(newValue);
			setIsCategory4Disabled(false);
		} else {
			setCategory4(newValue);
		}
	};

	useEffect(() => {
		axios
			.post(
				`${window.location.protocol}//${window.location.hostname}:3001/getVendor`,
				qs.stringify({
					token: localStorage.getItem('token'),
				})
			)
			.then((res) => {
				// setLogo(true);
				// setItems(res.data.productInfo || []);
				// setCount(res.data.productInfo.length);
				const valuesArray = res.data.map((obj) => obj.vendorCode);
				setVendorList(valuesArray);
				setCheckedVendor(valuesArray);
			})
			.catch();
		setSaleStatusList(['SALE', 'SOLDOUT', 'EXTINCTION', 'EXCEPTION']);
	}, []);

	const reset = (e) => {
		setCheckedSaleStatus(['SALE']);
		setManageCode('');
		setGoodsName('');
		setModelName('');
		setManufacturerName('');
		setBrandName('');
		setCategory1('');
		setIsCategory1Open(false);
		setIsCategory1Disabled(true);
		setCategory2('');
		setIsCategory2Open(false);
		setIsCategory2Disabled(true);
		setCategory3('');
		setIsCategory3Open(false);
		setIsCategory3Disabled(true);
		setCategory4('');
		setIsCategory4Open(false);
		setIsCategory4Disabled(true);
		setCheckedVendor(VendorList);
		setPeriod('등록기간');
		setIsPeriodOpen(false);
		setStartDate('');
		setEndDate('');
		setBtnClicked('');
	};

	const onSearch = (e) => {
		e.preventDefault();

		const newParams = {
			commodityCode: manageCode,
			name: GoodsName,
			dt: {
				periodType: StartDate && EndDate ? changePeriodData(Period) : null,
				before: StartDate,
				after: EndDate,
			},
			model: ModelName,
			manufacturer: ManufacturerName,
			brand: BrandName,
			status: CheckedSaleStatus,
			// category: {
			// 	category1: Category1,
			// 	category2: Category2,
			// 	category3: Category3,
			// 	category4: Category4,
			// },
			vendorCode: CheckedVendor,
		};
		props.getParams(newParams);
	};
	const handleBlurPeriodContainer = () => {
		setTimeout(() => {
			setIsPeriodOpen(false);
		}, 200);
	};
	const handlePeriodOpen = (e) => {
		e.preventDefault();
		setIsPeriodOpen(!IsPeriodOpen);
	};
	const handlePeriod = (e) => {
		e.preventDefault();
		const newPeriod = e.target.innerText;
		if (Period !== newPeriod) {
			setPeriod(newPeriod);
			return;
		}
	};

	useEffect(() => {
		const newCountParmas = props.countParams;
		reset();
		if (newCountParmas.status?.length > 0) {
			if (newCountParmas.status.includes('SOLDOUT, EXTINCTION')) {
				setCheckedSaleStatus(['SOLDOUT', 'EXTINCTION']);
			} else {
				setCheckedSaleStatus(newCountParmas.status);
			}
		}
		return;
	}, [props.countParams]);
	useEffect(() => {
		const newIs = props.isLoading;
		setIsDisable(newIs);
	}, [props.isLoading]);

	return (
		<>
			<form className='searchForm' onSubmit={(e) => onSearch(e)}>
				<table>
					<tbody>
						<tr>
							<th>검색어</th>
							<td>
								<div className='searchWord'>
									<div>
										<label>
											<span>판매자상품코드<br />등록상품코드</span>
											<textarea
												// style={{ resize: 'none' }}
												name='manageCode'
												id='manageCode'
												cols='30'
												rows='5'
												onChange={(e) => handleInputChange(e.target.value, 'manageCode')}
											></textarea>
										</label>
									</div>
									<div>
										<label htmlFor='GoodsName'>
											<span>상품명</span>
											<input type='text' id='GoodsName' name='GoodsName' onChange={(e) => handleInputChange(e.target.value, 'GoodsName')} value={GoodsName || ''} />
										</label>
										<label htmlFor='ModelName'>
											<span>모델명</span>
											<input type='text' id='ModelName' name='ModelName' onChange={(e) => handleInputChange(e.target.value, 'ModelName')} value={ModelName || ''} />
										</label>
									</div>
									<div>
										<label htmlFor='ManufacturerName'>
											<span>제조사명</span>
											<input type='text' id='ManufacturerName' name='ManufacturerName' onChange={(e) => handleInputChange(e.target.value, 'ManufacturerName')} value={ManufacturerName || ''} />
										</label>
										<label htmlFor='BrandName'>
											<span>브랜드명</span>
											<input type='text' id='BrandName' name='BrandName' onChange={(e) => handleInputChange(e.target.value, 'BrandName')} value={BrandName || ''} />
										</label>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th>판매상태</th>
							<td>
								<CheckBox
									itemList={SaleStatusList}
									getCheckedList={(e) => setCheckedSaleStatus(e)}
									updateList={CheckedSaleStatus}
									defaultCheckedList={['SALE', 'SOLDOUT', 'EXTINCTION', 'EXCEPTION']}
									isAllCheck={false}
									parseStatus={changeSaleStatusData}
								/>
							</td>
						</tr>
						<tr>
							<th>카테고리</th>
							<td>
								<div className='categoriesContainer'>
									<div className='container' onBlur={(e) => handleBlurCategory(e, 'category1')}>
										<label onClick={(e) => handleCategoryOpen(e, 'category1')}>
											<button className='dropdown-button' disabled={IsCategory1Disabled}>
												<span>{Category1 ? Category1 : '대분류'}</span>
												<span className='dropdown-button-arrow'>{IsCategory1Open ? '▲' : '▼'}</span>
											</button>
										</label>
										{IsCategory1Open && (
											<div className={IsCategory1Open ? 'dropdown-container open' : 'dropdown-container'}>
												<ul className='dropdown-content'>
													{Category1List.map((el, idx) => (
														<li key={idx} onClick={(e) => handleCategory(e, 'category1')}>
															{el}
														</li>
													))}
												</ul>
											</div>
										)}
									</div>
									<div className='container' onBlur={(e) => handleBlurCategory(e, 'category2')}>
										<label onClick={(e) => handleCategoryOpen(e, 'category2')}>
											<button className='dropdown-button' disabled={IsCategory2Disabled}>
												<span>{Category2 ? Category2 : '중분류'}</span>
												<span className='dropdown-button-arrow'>{IsCategory2Open ? '▲' : '▼'}</span>
											</button>
										</label>
										{IsCategory2Open && (
											<div className={IsCategory2Open ? 'dropdown-container open' : 'dropdown-container'}>
												<ul className='dropdown-content'>
													{Category2List.map((el, idx) => (
														<li key={idx} onClick={(e) => handleCategory(e, 'category2')}>
															{el}
														</li>
													))}
												</ul>
											</div>
										)}
									</div>
									<div className='container' onBlur={(e) => handleBlurCategory(e, 'category3')}>
										<label onClick={(e) => handleCategoryOpen(e, 'category3')}>
											<button className='dropdown-button' disabled={IsCategory3Disabled}>
												<span>{Category3 ? Category3 : '소분류'}</span>
												<span className='dropdown-button-arrow'>{IsCategory3Open ? '▲' : '▼'}</span>
											</button>
										</label>
										{IsCategory3Open && (
											<div className={IsCategory3Open ? 'dropdown-container open' : 'dropdown-container'}>
												<ul className='dropdown-content'>
													{Category3List.map((el, idx) => (
														<li key={idx} onClick={(e) => handleCategory(e, 'category3')}>
															{el}
														</li>
													))}
												</ul>
											</div>
										)}
									</div>
									<div className='container' onBlur={(e) => handleBlurCategory(e, 'category4')}>
										<label onClick={(e) => handleCategoryOpen(e, 'category4')}>
											<button className='dropdown-button' disabled={IsCategory4Disabled}>
												<span>{Category4 ? Category4 : '세분류'}</span>
												<span className='dropdown-button-arrow'>{IsCategory4Open ? '▲' : '▼'}</span>
											</button>
										</label>
										{IsCategory4Open && (
											<div className={IsCategory4Open ? 'dropdown-container open' : 'dropdown-container'}>
												<ul className='dropdown-content'>
													{Category4List.map((el, idx) => (
														<li key={idx} onClick={(e) => handleCategory(e, 'category4')}>
															{el}
														</li>
													))}
												</ul>
											</div>
										)}
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<th>도매사</th>
							<td>
								{VendorList.length > 0 && ( //받아오는 값들은 length체크해줘야함.
									<CheckBox itemList={VendorList} updateList={CheckedVendor} getCheckedList={(e) => setCheckedVendor(e)} isAllCheck={true} />
								)}
							</td>
						</tr>
						<tr>
							<th>기간</th>
							<td>
								<div className='datePickerBox'>
									<div className='container' onBlur={(e) => handleBlurPeriodContainer(e)}>
										<label onClick={(e) => handlePeriodOpen(e)}>
											<button className='dropdown-button'>
												<span>{Period}</span>
												<span className='dropdown-button-arrow'>{IsPeriodOpen ? '▲' : '▼'}</span>
											</button>
										</label>
										{IsPeriodOpen && (
											<div className={IsPeriodOpen ? 'dropdown-container open' : 'dropdown-container'}>
												<ul className='dropdown-content'>
													{PageLengthList.map((el, idx) => (
														<li key={idx} onClick={(e) => handlePeriod(e)}>
															{el}
														</li>
													))}
												</ul>
											</div>
										)}
									</div>
									<div>
										{DateFilterButtonData.map((el, index) => (
											<input type='button' id={el} onClick={(e) => handleBtnClicked(e)} key={index} className={BtnClicked === el ? 'isActive' : ''} value={el || ''} />
										))}
									</div>
									<div className='datePicker'>
										<DatePicker
											locale={ko} // 언어설정 기본값은 영어
											dateFormat='yyyy-MM-dd' // 날짜 형식 설정
											className='input-datepicker' // 클래스 명 지정 css주기 위해
											closeOnScroll={true} // 스크롤을 움직였을 때 자동으로 닫히도록 설정 기본값 false
											placeholderText='시작일 선택'
											selected={StartDate} // value
											onChange={(date) => {
												changeClassName(BtnClicked, '');
												setStartDate(date.valueOf());
											}} // 날짜를 선택하였을 때 실행될 함수
											onMonthChange={handleMonthChange}
										/>
										<span>~</span>
										<DatePicker
											locale={ko}
											dateFormat='yyyy-MM-dd'
											className='input-datepicker'
											minDate={StartDate} // 선택할 수 있는 최소 날짜값 지정
											closeOnScroll={true}
											placeholderText='종료일 선택'
											selected={EndDate}
											onChange={(date) => {
												changeClassName(BtnClicked, '');
												setEndDate(date.valueOf());
											}}
											onMonthChange={handleMonthChange}
										/>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<div className='searchBottonBox'>
					<button type='reset' onClick={reset}>
						<span>
							<img src={resetIcon} alt='resetIcon' />
						</span>
						{/* <a href="https://www.flaticon.com/kr/free-icons/" title=" 아이콘" > 아이콘  제작자: Taufik - Flaticon</a> */}
						<span>초기화</span>
					</button>
					<button type='submit' disabled={IsDisable ? true : false}>
						검색
					</button>
				</div>
			</form>
		</>
	);
}

export default HubSearch;
